export default "Questa vista offre una panoramica riassuntiva sul **Report Chiamate & Costi**, sono sempre esclusi i dati del giorno corrente.\n";